@if (visible) {
  <div [@customModalForm] class="custom-modal-form">
    <ng-content></ng-content>
    @if (closable) {
      <button (click)="close()" aria-label="Close" class="custom-modal-form__close-btn">X</button>
    }
  </div>
}
@if (visible) {
  <div class="overlay" (click)="close()"></div>
}